export default __webpack_public_path__ + "static/media/message-edit.e1716400.svg";